module.exports = __webpack_public_path__ + "static/media/cluster.5f3f1e2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/cluster.svg
// module id = 1585
// module chunks = 0